import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AppError } from "@/jenesys-types/errors";

interface LinkDocumentState {
  isLoading: boolean;
  error?: AppError;
}

const initialState: LinkDocumentState = {
  isLoading: false,
  error: undefined
};

export interface LinkDocumentPayload {
  companyId: string;
  transactionId: string;
  documentId: string;
}

const linkDocumentSlice = createSlice({
  name: "linkDocument",
  initialState,
  reducers: {
    linkDocument: {
      reducer: (state: LinkDocumentState, action: PayloadAction<LinkDocumentPayload>) => {
        state.isLoading = true;
        state.error = undefined;
      },
      prepare: (companyId: string, transactionId: string, documentId: string) => {
        const payload = { companyId, transactionId, documentId };
        return { payload };
      }
    },
    linkDocumentSuccess: {
      reducer: (state: LinkDocumentState) => {
        state.isLoading = false;
        state.error = undefined;
      },
      prepare: () => ({
        payload: undefined
      })
    },
    linkDocumentFailure: {
      reducer: (state: LinkDocumentState, action: PayloadAction<AppError>) => {
        state.isLoading = false;
        state.error = action.payload;
      },
      prepare: (error: AppError) => ({
        payload: error
      })
    }
  }
});

export const {
  linkDocument,
  linkDocumentSuccess,
  linkDocumentFailure
} = linkDocumentSlice.actions;

export const selectLinkDocumentState = (state: any): LinkDocumentState => state.features.transactions.linkDocument;
export const selectLinkDocumentLoading = (state: any): boolean => selectLinkDocumentState(state).isLoading;
export const selectLinkDocumentError = (state: any): AppError | undefined => selectLinkDocumentState(state).error;

export default linkDocumentSlice.reducer;